import React from 'react';
import { heroData } from '../mock';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToCollections = () => {
    const element = document.querySelector('#collections');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#f7f5f2]">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#dc143c] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#1a1a2e] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="space-y-8 animate-fade-in">
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold tracking-tight leading-none">
            <span className="text-[#dc143c]">BHARGAVA'S</span>{' '}
            <span className="text-[#1a1a2e]">SHOES</span>
          </h1>
          
          <p className="text-2xl md:text-3xl text-[#1a1a2e] font-medium tracking-wide">
            {heroData.subtitle}
          </p>
          
          <p className="text-xl text-[#dc143c] font-semibold tracking-widest uppercase">
            {heroData.tagline}
          </p>

          <p className="text-lg md:text-xl text-[#736c64] max-w-2xl mx-auto leading-relaxed">
            {heroData.description}
          </p>

          <div className="pt-8 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={scrollToCollections}
              className="group flex items-center gap-3 bg-[#dc143c] text-white px-8 py-4 rounded-sm text-lg font-medium hover:bg-[#b01030] transition-all duration-300 hover:gap-5"
            >
              <span>{heroData.cta}</span>
              <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            
            <a
              href="#contact"
              className="flex items-center gap-3 border-2 border-[#1a1a2e] text-[#1a1a2e] px-8 py-4 rounded-sm text-lg font-medium hover:bg-[#1a1a2e] hover:text-white transition-all duration-300"
            >
              Visit Showroom
            </a>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center space-y-2">
            <p className="text-4xl md:text-5xl font-bold text-[#dc143c]">1000+</p>
            <p className="text-sm text-[#666] tracking-wider uppercase">Styles</p>
          </div>
          <div className="text-center space-y-2">
            <p className="text-4xl md:text-5xl font-bold text-[#dc143c]">50+</p>
            <p className="text-sm text-[#666] tracking-wider uppercase">Brands</p>
          </div>
          <div className="text-center space-y-2">
            <p className="text-4xl md:text-5xl font-bold text-[#dc143c]">110+</p>
            <p className="text-sm text-[#666] tracking-wider uppercase">Years Legacy</p>
          </div>
          <div className="text-center space-y-2">
            <p className="text-4xl md:text-5xl font-bold text-[#dc143c]">5000+</p>
            <p className="text-sm text-[#666] tracking-wider uppercase">Happy Customers</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#dc143c] rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-2 bg-[#dc143c] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
